import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKeepNutshell = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 160,
	height: 32,
	viewBox: "0 0 160 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M25.3281 6.3125H152.733C156.215 6.3125 159.037 9.13514 159.037 12.6171V20.8806C159.037 24.3625 156.215 27.1851 152.733 27.1851H25.3281V6.3125Z",
			fill: "#0C0F33"
		}),
		/* @__PURE__ */ _jsx("text", {
			x: 42,
			y: 20.5,
			fill: "#FFFFFF",
			fontFamily: "IBM Plex Sans, Helvetica, Arial, sans-serif",
			fontSize: 11,
			fontWeight: 500,
			letterSpacing: -.11,
			children: "KEEP NUTSHELL"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 32,
			height: 32,
			rx: 16,
			fill: "#FE5800"
		}),
		/* @__PURE__ */ _jsx("path", {
			transform: "translate(10.4 9.2)",
			d: "M8.53 0.0978471C8.7575 0.247847 8.855 0.530347 8.77 0.787847L7.3 5.20035H10.3225C10.8075 5.20035 11.2 5.59285 11.2 6.07785C11.2 6.32785 11.095 6.56535 10.9075 6.73035L3.4 13.4478C3.1975 13.6303 2.8975 13.6528 2.67 13.5028C2.4425 13.3528 2.345 13.0703 2.43 12.8128L3.9 8.40035H0.8775C0.3925 8.40035 0 8.00785 0 7.52285C0 7.27535 0.105 7.03785 0.2925 6.87035L7.8 0.152847C8.0025 -0.029653 8.3025 -0.0496529 8.53 0.0978471ZM1.7225 7.20035H4.7325C4.925 7.20035 5.1075 7.29285 5.22 7.45035C5.3325 7.60785 5.3625 7.80785 5.3025 7.99035L4.2825 11.0478L9.4775 6.40035H6.4675C6.275 6.40035 6.0925 6.30785 5.98 6.15035C5.8675 5.99285 5.8375 5.79285 5.8975 5.61035L6.9175 2.55285L1.7225 7.20035Z",
			fill: "white"
		})
	]
});
export default SvgKeepNutshell;
